// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"455fc4a8","667":"5c08ee0f"}[chunkId] + ".chunk.js";
};